import React, { useState } from 'react';
import PersianNumberInput from '../pages/tools/NumberInput';
import api from '../api/api';
import { Alert } from '@material-tailwind/react';
import { useNavigate } from 'react-router-dom';

export default function PhoneLogin({ onLogin, setUserPhone }) {
  const [step, setStep] = useState('phone'); // 'phone' | 'otp'
  const [phone, setPhone] = useState('');
  const [otp, setOtp] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const navigate = useNavigate();
  const sendOtp = async () => {
    setError('');
    if (!/^09\d{9}$/.test(phone)) {
      setError('شماره تلفن معتبر نیست');
      return;
    }

    setLoading(true);
    try {
      const { data } = await api.post('/send-otp', { phone });
      if (data.ok) {
        setStep('otp');
        setMessage('کد یکبار مصرف به موبایل شما ارسال شد');
      } else {
        setError(data.message || 'خطا در ارسال کد');
      }
    } catch (err) {
      setError(err.response?.data?.message || 'خطا در ارتباط با سرور');
    }
    setLoading(false);
  };

  const verifyOtp = async () => {
    setError('');
    if (!otp) {
      setError('لطفاً کد OTP را وارد کنید');
      return;
    }

    setLoading(true);
    try {
      const { data } = await api.post('/verify-otp', { phone, otp });
      console.log('verif data', data);
      if (data.ok && data.token) {
        localStorage.setItem('aziAuthToken', data.token);
        setUserPhone(phone);
        onLogin(data.token);
        localStorage.setItem('phone', phone);
        // alert('ورود موفقیت آمیز بود!');
        setStep('phone');
        setPhone('');
        setOtp('');
      } else {
        setError(data.message || 'کد OTP اشتباه است');
      }
    } catch (err) {
      setError(err.response?.data?.message || 'خطا در ارتباط با سرور');
    }
    setLoading(false);
  };

  return (
    <div className="max-w-sm mx-auto mt-10 p-4 border rounded shadow">
      <h2 className="text-lg font-bold mb-4 text-center">
        <p>برای دریافت آنالیز رایگان</p>
      </h2>
      <h2 className="text-xs font-bold mb-4 text-center">
        لطفا شماره موبایل خود را وارد کنید
      </h2>
      {error && <p className="text-red-500 mb-2">{error}</p>}

      {step === 'phone' && (
        <>
          <label className="block mb-2">شماره موبایل</label>
          <PersianNumberInput
            value={phone}
            className="mt-2 block w-full rounded-md border-0 py-1.5 text-main shadow-sm ring-1 ring-inset ring-main placeholder:text-main focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
            onChange={(val) => setPhone(val)} // val is the number/string directly
          />

          <button
            className="w-full bg-blue-500 text-white py-2 rounded mt-3"
            onClick={sendOtp}
            disabled={loading}>
            {loading ? 'ارسال...' : 'ارسال کد تایید'}
          </button>

          <button
            className="w-full bg-blue-500 text-white py-2 rounded mt-3"
            onClick={() => {
              navigate('/result');
            }}>
            مشاهده نتایج قبلی
          </button>
        </>
      )}
      {message.length > 1 && (
        <div
          class="flex mt-2 items-center bg-green-500 text-white text-sm font-bold px-4 py-3 rounded"
          role="alert">
          <svg
            class="fill-current w-4 h-4 mr-2"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20">
            <path d="M12.432 0c1.34 0 2.01.912 2.01 1.957 0 1.305-1.164 2.512-2.679 2.512-1.269 0-2.009-.75-1.974-1.99C9.789 1.436 10.67 0 12.432 0zM8.309 20c-1.058 0-1.833-.652-1.093-3.524l1.214-5.092c.211-.814.246-1.141 0-1.141-.317 0-1.689.562-2.502 1.117l-.528-.88c2.572-2.186 5.531-3.467 6.801-3.467 1.057 0 1.233 1.273.705 3.23l-1.391 5.352c-.246.945-.141 1.271.106 1.271.317 0 1.357-.392 2.379-1.207l.6.814C12.098 19.02 9.365 20 8.309 20z" />
          </svg>
          <p>{message}</p>
        </div>
      )}
      {step === 'otp' && (
        <>
          <label className="block mb-2">کد تایید</label>
          <PersianNumberInput
            value={otp}
            className="mt-2 block w-full rounded-md border-0 py-1.5 text-main shadow-sm ring-1 ring-inset ring-main placeholder:text-main focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
            onChange={(val) => setOtp(val)}
            placeholder="کد دریافتی"
          />
          <button
            className="w-full mt-2 bg-green-500 text-white py-2 rounded mb-2"
            onClick={verifyOtp}
            disabled={loading}>
            {loading ? 'در حال بررسی...' : 'تایید کد'}
          </button>
          <button
            className="w-full bg-gray-300 text-black py-2 rounded"
            onClick={() => setStep('phone')}
            disabled={loading}>
            تغییر شماره
          </button>
        </>
      )}
    </div>
  );
}
